<template>
    <b-modal ref="mdlRsaPazienteRiepilogoOperatoriEquipeListModalComponent" size="xl" style="height: 100%" no-close-on-backdrop title="" dialog-class="sa-modal-full-height">
        <template #modal-title>Riepilogo equipe</template>
        <div class="sa-list-component">
            <div class="sa-list-component-header">
                <sa-filter-component @submit="onSubmit" @reset="resetFiltro(tipoTab)">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Cognome Paziente</label>
                            <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                <input class="sa-page-search-component-input" v-model="filtroRiepilogoEquipe.cognomePaziente" placeholder="Inserisci un cognome.." />
                            </div>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Nome Paziente</label>
                            <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                <input class="sa-page-search-component-input" v-model="filtroRiepilogoEquipe.nomePaziente" placeholder="Inserisci un nome.." />
                            </div>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Data dal:</label>
                            <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                <date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" v-model="filtroRiepilogoEquipe.dataDal" placeholder="Inserire una data..." />
                            </div>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Data al</label>
                            <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                <date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" v-model="filtroRiepilogoEquipe.dataAl" placeholder="Inserire una data..." />
                            </div>
                        </b-col>
                    </b-row>
                </sa-filter-component>
            </div>
            <div class="sa-list-component-body">
                <b-tabs v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onChangeTab">
                    <b-tab title="Attive" active>
                        <div class="sa-table-wrapper">
                            <b-table sticky-header stacked="lg" striped hover :items="itemsEquipe" :fields="fieldsEquipe" :per-page="perPage" :key="listKey" head-variant="light" class="sa-table-scroll">
                                <template #cell(index)="row">
                                    <span> {{ (currentPage - 1) * perPage + row.index + 1 }} </span>
                                </template>
                                <template v-slot:cell(equipe)="{ item }">
                                    <span>EQUIPE DI {{ item.nomePaziente }} {{ item.cognomePaziente }}</span>
                                </template>

                                <template v-slot:cell(dataInizio)="{ item }">
                                    <span>{{ formatDateTime(item.dataInizio) }}</span>
                                </template>

                                <template v-slot:cell(dataFine)="{ item }">
                                    <span>{{ formatDateTime(item.dataFine) }}</span>
                                </template>
                            </b-table>
                        </div>
                    </b-tab>

                    <b-tab title="Storico">
                        <div class="sa-table-wrapper">
                            <b-table sticky-header stacked="lg" striped hover :items="itemsEquipe" :fields="fieldsEquipe" :per-page="perPage" :key="listKey" head-variant="light" class="sa-table-scroll">
                                <template #cell(index)="row">
                                    <span> {{ (currentPage - 1) * perPage + row.index + 1 }} </span>
                                </template>
                                <template v-slot:cell(equipe)="{ item }">
                                    <span>EQUIPE DI {{ item.nomePaziente }} {{ item.cognomePaziente }}</span>
                                </template>

                                <template v-slot:cell(dataInizio)="{ item }">
                                    <span>{{ formatDateTime(item.dataInizio) }}</span>
                                </template>

                                <template v-slot:cell(dataFine)="{ item }">
                                    <span>{{ formatDateTime(item.dataFine) }}</span>
                                </template>
                            </b-table>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import SaFilterComponent from "../../../../template/layout/components/SaFilterComponent.vue";
import DatePicker from "vue2-datepicker";
export default {
    components: { DatePicker, SaFilterComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            perPage: 50,
            currentPage: 1,
            page: 1,
            activeTabIndex: 0,
            listKey: 0,
            itemsEquipe: [],
            fieldsEquipe: [
                {
                    label: "",
                    key: "index",
                    thStyle: "width: 4rem",
                },
                { label: "Equipe", key: "equipe" },
                {
                    label: "Data Inizio",
                    key: "dataInizio",
                },
                {
                    label: "Data Fine",
                    key: "dataFine",
                },
            ],
            tipoTab: "ATTIVE",
            pathResourceEquipeDettaglio: "/rsaequipedettaglio",
            filtroRiepilogoEquipe: { nomePaziente: null, cognomePaziente: null, dataDal: null, dataAl: null, username: null, tipoTab: null },
            rigaSelezionata: null,
            rows: 0,
        };
    },

    mounted() {
        let me = this;
        if (sessionStorage["filtroRiepilogoEquipe"]) {
            me.filtroRiepilogoEquipe = JSON.parse(sessionStorage["filtroRiepilogoEquipe"]);
        }
    },

    watch: {
        currentPage() {
            let me = this;
            if (me.tipoTab === "ATTIVE") {
                me.loadEquipeAttive();
            } else {
                me.loadEquipeStorico();
            }
        },
    },
    methods: {
        init(row) {
            let me = this;
            me.visibleFields = me.fields;
            me.$refs.mdlRsaPazienteRiepilogoOperatoriEquipeListModalComponent.show();
            me.rigaSelezionata = row.item;
            me.loadEquipeAttive();
        },
        onChangeTab(index) {
            this.tipoTab = index === 0 ? "ATTIVE" : "STORICO";
            this.resetFiltro(this.tipoTab);
            switch (index) {
                case 0:
                    this.loadEquipeAttive();
                    break;

                case 1:
                    this.loadEquipeStorico();
                    break;
                default:
                    break;
            }
        },
        loadEquipeStorico() {
            let me = this;
            me.itemsEquipe = [];
            me.filtroRiepilogoEquipe.tipoTab = "STORICO";
            me.filtroRiepilogoEquipe.username = me.rigaSelezionata.username;
            me.filtroRiepilogoEquipe.forPage = me.perPage;
            me.filtroRiepilogoEquipe.page = me.currentPage;
            UtilityMixin.methods.loadDataResources(me.pathResourceEquipeDettaglio + "/dettaglio", me.filtroRiepilogoEquipe, me.loadEquipeStoricoSuccess, me.loadEquipeStoricoError);
        },
        loadEquipeStoricoSuccess(response) {
            let me = this;
            me.itemsEquipe = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
        },
        loadEquipeStoricoError(response) {
            console.log("errore response", response);
        },
        onSubmit() {
            let me = this;
            me.$emit("onBeforeLoadData", true);
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroRiepilogoEquipe"] = JSON.stringify(me.filtroRiepilogoEquipe);
            if (me.tipoTab === "ATTIVE") {
                this.loadEquipeAttive();
            } else {
                this.loadEquipeStorico();
            }
        },
        loadEquipeAttive() {
            let me = this;
            me.itemsEquipe = [];
            me.filtroRiepilogoEquipe.tipoTab = "ATTIVE";
            me.filtroRiepilogoEquipe.username = me.rigaSelezionata.username;
            me.filtroRiepilogoEquipe.forPage = me.perPage;
            me.filtroRiepilogoEquipe.page = me.currentPage;
            UtilityMixin.methods.loadDataResources(me.pathResourceEquipeDettaglio + "/dettaglio", me.filtroRiepilogoEquipe, me.loadEquipeAttiveSuccess, me.loadEquipeAttiveError);
        },
        loadEquipeAttiveSuccess(response) {
            let me = this;
            me.itemsEquipe = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
        },
        loadEquipeAttiveError(response) {
            console.log("errore response", response);
        },
        resetFiltro() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroRiepilogoEquipe"] = JSON.stringify(me.filtroRiepilogoEquipe);
            me.filtroRiepilogoEquipe = { nomePaziente: null, cognomePaziente: null, dataDal: null, dataAl: null, username: null, tipoTab: this.tipoTab };
            me.onSubmit();
        },
    },
};
</script>
<style scoped>
.sa-date-like-input ::v-deep .mx-icon-calendar {
    display: none !important;
}
.sa-tab {
    height: 100%;
}

.sa-tab ::v-deep .tab-content {
    height: 100%;
    min-height: 0;
}

.sa-tab ::v-deep .tab-pane {
    height: 100%;
    min-height: 0;
}

.sa-table-wrapper {
    height: 100%;
    min-height: 0;
    overflow-y: auto;
}
</style>
